import { render, staticRenderFns } from "./BuscaAvancada.vue?vue&type=template&id=b7b2d41c&scoped=true"
import script from "./BuscaAvancada.vue?vue&type=script&lang=js"
export * from "./BuscaAvancada.vue?vue&type=script&lang=js"
import style0 from "./BuscaAvancada.vue?vue&type=style&index=0&id=b7b2d41c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b2d41c",
  null
  
)

export default component.exports